import { QueryClient } from '@tanstack/react-query';

/**
 * Application-wide React Query client singleton.
 *
 * Why a singleton (instead of `new QueryClient()` inline in `main.tsx`):
 * code that runs outside the React tree — most importantly the session
 * expiry handler in `src/shared/utils/sessionHandler.ts` and the central
 * teardown helper in `src/shared/utils/clearSession.ts` — needs to be able
 * to clear the query cache when the session ends. Importing this module
 * from those files gives them the same instance that `<QueryClientProvider>`
 * is rendering.
 *
 * Test files and Storybook stories continue to construct their own isolated
 * `QueryClient` instances; that's intentional for test/story isolation and
 * should not be changed.
 */
export const queryClient = new QueryClient();
